import { httpPost } from './httpPost';

export const passwordlessEmail = {
	post: httpPost
};
